import React, { useEffect, useRef } from 'react';
import '../../styles/money.css';
import '../../styles/guests.css';
import RequireEvent from '../../components/RequireEvent';
import { choose } from '../../utils/platform';
import { useCards } from './useCards';
import { useMembers } from '../members/useMembers';
import MemberForm from '../members/MemberForm';
import CardsDesktop from './Cards.desktop';
import CardsMobile from './Cards.mobile';

const CardsView = choose(CardsDesktop, CardsMobile);

function CardsInner({ event }) {
  const vm = useCards(event);
  // Card distribution is the screen the day is run from, so a guest or a whole
  // family can be added without leaving it - the SAME dialogs the Guests page
  // uses, driven by the same hook, never a second copy of the save logic.
  const guests = useMembers(event);

  // The two hooks hold their own copy of the guest list; when one saves, the
  // cards are re-read so the new household appears as a card at once.
  const firstRows = useRef(guests.rows);
  useEffect(() => {
    if (guests.rows !== firstRows.current) vm.refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guests.rows]);

  return (
    <>
      <CardsView vm={{ ...vm, guests }} />
      {guests.open && <MemberForm vm={guests} />}
    </>
  );
}

// /app/cards — card distribution: whose round a card is on, whether it has
// been given and when, plus the printable list of names and what to order.
export default function Cards() {
  return <RequireEvent>{(event) => <CardsInner event={event} />}</RequireEvent>;
}
